import { useMemo } from 'react'

const useObserver = () => {
  const otpStorage = sessionStorage.getItem('otp')
  return useMemo(() => {
    if (otpStorage) {
      const { otp, accountId, adAccountId } = JSON.parse(otpStorage)
      return {
        otp,
        targetId: adAccountId,
        observerId: accountId,
      }
    } else {
      return undefined
    }
  }, [otpStorage])
}
export default useObserver
